import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';
import {SliderResponseModel} from '@shared/components/slider/model/slider-response.model';
import {ConsentUseCaseLetterEnum} from '../../../../consent-use-case/enums/consent-use-case.enum-letter';
import {ProvisionDurationEnum} from '@core/modules/rest/indication/enums/provisionDurationEnum';
import {ConversionsService} from '@shared/utils/conversions.service';

@Component({
    selector: 'app-level-of-detail',
    templateUrl: './level-of-detail.component.html',
    styleUrls: ['./level-of-detail.component.scss']
})
export class LevelOfDetailComponent {

    @Input() provisionDurationValues: string[] | undefined;
    @Input() provisionDuration: ProvisionDurationEnum | undefined;
    @Input() durationInMillis: number | undefined;
    @Input() useCaseDetails: ConsentUseCaseBasicModel | undefined;
    @Input() consentUseCaseValues: string[] | undefined;
    @Input() defaultLevels: { unitId: string, unitLevel: ConsentUseCaseLetterEnum }[] | undefined;
    @Output() sliderChangeEvent: EventEmitter<SliderResponseModel> = new EventEmitter<SliderResponseModel>();
    @Output() relevanceChangeEvent: EventEmitter<SliderResponseModel> = new EventEmitter();

    defaultLevel = ProvisionDurationEnum.BASIC;

    constructor(private conversionsService: ConversionsService) {
    }

    getDefaultLevelFromId(unitId: string): ConsentUseCaseLetterEnum {
        const defaultSelected = this.defaultLevels?.find(item => item.unitId === unitId);
        if (defaultSelected) {
            return defaultSelected.unitLevel;
        }
        return ConsentUseCaseLetterEnum.D;
    }

    getMinutes(millis: number): string {
        return this.conversionsService.getMinutesFromMillis(millis);
    }
}
